import WithSignoutModal from './View';
import { SignoutModalProps } from './types';

export type { SignoutModalProps };
export default WithSignoutModal;
